export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-img3-30e4acded3b344cc2ae3009bcdd4bfb3.jpg";